// removed by extract-text-webpack-plugin
module.exports = {"ant-modal-wrap":"ant-modal-wrap","compare-modal-wrap":"compare-modal-wrap","compare-modal":"compare-modal","compareWrap":"compareWrap","result-left":"result-left","result-right":"result-right","reportResultTitle":"reportResultTitle","circle":"circle","sub-title":"sub-title","resultDetailList":"resultDetailList"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/normal/azf/ReportDetail/CompareModal.scss
// module id = 1395
// module chunks = 0